(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("p4kFq", function(module, exports) {
parcelRequire("dhPSA");

});
parcelRegister("dhPSA", function(module, exports) {
"use strict";
const $9ac51b1704e4d3f9$var$inputs = document.querySelectorAll("input.js-honey");
if ($9ac51b1704e4d3f9$var$inputs.length) {
    const now = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
    setTimeout(function() {
        $9ac51b1704e4d3f9$var$inputs.forEach((input)=>{
            input.value = `abcd1234-${now}`;
        });
    }, 5000);
}

});


})();
//# sourceMappingURL=honey.c494935c.js.map
